import type { Content } from '../../models';

import { VisualsWithDataTypes } from '../../config/constants';

export const validateContentVersion67 = (content: Content): boolean => {
  const { type, typeSpecific } = content;

  if (typeSpecific.version < 67) {
    if (VisualsWithDataTypes.includes(type)) {
      const { inVisualFilter, style } = typeSpecific;

      if (style?.inVisualFilter) {
        // add new buttons style
        style.inVisualFilter.buttons = style.inVisualFilter.buttons ?? {
          grow: false,
          wrap: true,
          position: 'center',
          borderRadius: 4,
          border: {
            size: {
              top: 1,
              right: 1,
              bottom: 1,
              left: 1,
            },
            color: '#ccc',
            type: 'solid',
          },
          padding: {
            top: 4,
            topUnit: 'px',
            right: 4,
            rightUnit: 'px',
            bottom: 4,
            bottomUnit: 'px',
            left: 4,
            leftUnit: 'px',
          },
          gap: 8,
          color: '#444',
          background: '#ddd',
          activeColor: '#eee',
          activeBackground: '#3d4142',
        };
      }

      // each existing inVisFilter should have buttonsStyle
      if (Array.isArray(inVisualFilter)) {
        for (const filter of inVisualFilter) {
          filter.options.buttonsStyle = filter.options.buttonsStyle ?? {};
        }
      }
    }

    typeSpecific.version = 67;
  }

  return true;
};
